import { Signage } from '../Signage';
import { Log } from '../AuxillaryService/Log';
import { $ } from '../../vendor/jquery';
import _ from 'underscore';

/**
 * @class
 * @hideconstructor
 */
var Stats = {};

/**
 *
 * @param {*} array
 * @todo document this
 */
Stats.mean = function (array) {
    return (
        array.reduce(function (acc, cur) {
            return acc + cur;
        }) / array.length
    );
};

/**
 *
 * @param {*} array
 * @param {*} mean
 * @todo document this
 */
Stats.variance = function (array, mean) {
    var sumOfSquares = array.reduce(function (acc, cur) {
        return acc + Math.pow(cur, 2);
    }, 0);
    return sumOfSquares / array.length - Math.pow(mean, 2);
};

/**
 *
 * @param {*} array
 * @param {*} mean
 * @todo document this
 */
Stats.standardDeviation = function (array, mean) {
    return Math.sqrt(this.variance(array, mean));
};

// -------------------------------------------------------------------------- //

// region VideoPlaybackMonitor class

var MILLISECONDS_THRESHOLD = -33;
var TIME_UPDATE_LOG_THROTTLE_TIME = 200;

/**
 * Class that monitors the playback of a video
 * @param video
 * @constructor
 */
function VideoPlaybackMonitor(video) {
    /**
     * Video element being monitored
     * @type {HTMLMediaElement}
     */
    this.video = video;

    this.opaqueParent = null;

    this.data = {
        id: this.video.id,
        widgetId: getWidgetId(this.video),
        widgetType: $(this.video).closest('.widget')[0].dataset.name,
    };

    /**
     * JavaScript timer start timestamp (in milliseconds)
     * @type {number}
     */
    this.timerStart = null;

    /**
     * Whether 'emptied' event occurs before 'ended' event
     * @type {boolean}
     */
    this.emptiedBeforeVideoEnd = false;

    /**
     *
     * @type {boolean}
     */
    this.isPlaying = false;

    /**
     *
     * @type {boolean}
     */
    this.playbackError = false;

    /**
     * Timer data
     * @type {
        Array.<{
            videoTime: number,
            timerTime: number,
            absoluteTimeDiff: number,
            runningTimeDiffPerSecond: number
        }>
        }
     */
    this.timeUpdates = [];

    Log.Info('Playback Monitor started: ' + this.video.id, null, __fileline);

    this.boundHandleTimeUpdate = this.handleTimeUpdate.bind(this);
    this.boundHandlePlay = this.handlePlay.bind(this);
    this.boundHandleEnded = this.handleEnded.bind(this);
    this.boundHandleError = this.handleError.bind(this);
    this.boundHandleEmptied = this.handleEmptied.bind(this);
    this.boundHandleCanplay = this.handleCanPlay.bind(this);

    /**
     * Array of all listeners
     * @type {Array.<{event: string, handler: function}>}
     */
    this.listeners = [
        { event: 'canplay', handler: this.boundHandleCanplay },
        { event: 'ended', handler: this.boundHandleEnded },
        { event: 'emptied', handler: this.boundHandleEmptied },
        { event: 'error', handler: this.boundHandleError },
        { event: 'play', handler: this.boundHandlePlay },
        { event: 'timeupdate', handler: this.boundHandleTimeUpdate },
    ];

    try {
        this.video.addEventListener('canplay', this.boundHandleCanplay);
        this.video.addEventListener('ended', this.boundHandleEnded);
        this.video.addEventListener('error', this.boundHandleError);
        this.video.addEventListener('play', this.boundHandlePlay);
        this.video.addEventListener('timeupdate', this.boundHandleTimeUpdate);
    } catch (error) {
        Log.Error('Failed to start listener for ' + this.video.id, null, __fileline);
    }
}

/**
 * Calculate timer duration from timer start in seconds
 * @returns {number}
 */
VideoPlaybackMonitor.prototype.timerTime = function () {
    return Date.now() - this.timerStart;
};

/**
 * Calculate time difference since last 'timeupdate'
 *
 * Positive number video.currentTime is ahead. Negative number video.currentTime
 * is behind.
 * @param videoTime
 * @param timerTime
 * @returns {number}
 */
VideoPlaybackMonitor.prototype.runningTimeDiff = function (videoTime, timerTime) {
    var absoluteDiff;
    var timeDiffPerSecond;

    absoluteDiff = videoTime - timerTime;

    if (this.timeUpdates.length) {
        var lastTimeUpdate = this.timeUpdates.slice(-1)[0];
        if (timerTime !== lastTimeUpdate.timerTime) {
            timeDiffPerSecond =
                ((absoluteDiff - lastTimeUpdate.absoluteTimeDiff) /
                    (timerTime - lastTimeUpdate.timerTime)) *
                1000; // 1000 milliseconds per second
        } else {
            // two timeUpdates in the same JavaScript tick
            timeDiffPerSecond = 0;
        }
    } else {
        timeDiffPerSecond = (absoluteDiff / timerTime) * 1000; // 1000 milliseconds per second
    }

    return timeDiffPerSecond;
};

/**
 * Calculate the diff of video current time and javascript timer
 *
 * NOTE: 'timeupdate' seems to fire twice at end of video when
 * currentTime === duration
 */
VideoPlaybackMonitor.prototype.handleTimeUpdate = function () {
    // only handle time updates after handling play
    var videoTime = this.video.currentTime * 1000; // in milliseconds

    // if opaqueParent is known, don't start timer until after fade in complete
    if ((this.opaqueParent && this.opaqueParent.css('opacity') === '1') || !this.opaqueParent) {
        // videoTime of 0 skews standard deviation number
        if (videoTime > 400) {
            if (!this.timerStart) {
                // Correct start time for current time of video when timer start
                // is set
                this.timerStart = parseInt(Date.now() - videoTime);
            }
            var timerTime = this.timerTime();

            if (this.isPlaying && videoTime !== this.videoDuration) {
                if (
                    this.timeUpdates.length === 0 ||
                    timerTime - this.timeUpdates.slice(-1)[0].timerTime >
                        TIME_UPDATE_LOG_THROTTLE_TIME
                ) {
                    this.timeUpdates.push({
                        videoTime: videoTime,
                        timerTime: timerTime,
                        absoluteTimeDiff: videoTime - timerTime,
                        runningTimeDiffPerSecond: this.runningTimeDiff(videoTime, timerTime),
                    });
                }
            }
        }
    }
};

/**
 * Start timer and start listening for 'emptied'
 */
VideoPlaybackMonitor.prototype.handlePlay = function () {
    this.isPlaying = true;

    // look for an opaque parent element
    if (!this.opaqueParent) {
        var parents = $(this.video).parents('div');

        parents.each(
            function (index, parent) {
                var opacity = parseFloat($(parent).css('opacity'));
                if (opacity < 1) {
                    this.opaqueParent = $(parent);
                    return false; // exit the loop
                }
            }.bind(this)
        );
    }

    // Start listening for the emptied event after the play event in case the
    // 'emptied' event fires before the 'ended' event happens
    this.video.addEventListener('emptied', this.boundHandleEmptied);

    // if time updates do not occur before threshold, assume the video failed
    setTimeout(
        function () {
            if (this.timeUpdates.length === 0) {
                this.playbackError = true;
                this.logData();
            }
        }.bind(this),
        5000
    );
};

/**
 * Calculate the diff between the expected video duration and the timer
 *
 * NOTE: the endDiff is often greater than all but the final two timeupdate
 * diffs
 */
VideoPlaybackMonitor.prototype.handleEnded = function () {
    if (this.isPlaying) {
        this.endDiff = this.videoDuration - this.timerTime();
        this.isPlaying = false;
        this.logData();

        // reset the monitor
        // this.clearData();

        this.timeUpdates = [];
        this.timerStart = null;
        this.emptiedBeforeVideoEnd = false;
        this.playbackError = false;
    }
};

/**
 * Clean up and report error
 * @param data {Event} 'error'
 */
VideoPlaybackMonitor.prototype.handleError = function (data) {
    if (this.isPlaying) {
        this.playbackError = true;
        Log.Warning('Video Error: ' + data.target.error.message, data.target.error.code);
    }
};

VideoPlaybackMonitor.prototype.clearData = function () {
    this.timeUpdates = [];
    this.timerStart = null;
    this.emptiedBeforeVideoEnd = false;
    this.playbackError = false;
};

/**
 * For concluding monitor when 'emptied' fires before 'ended'
 */
VideoPlaybackMonitor.prototype.handleEmptied = function () {
    if (this.isPlaying) {
        this.emptiedBeforeVideoEnd = true;
        this.handleEnded();
    }
};

/**
 *
 * Store the video duration in case the video is emptied before the 'ended'
 * event. Video duration is known when 'canplay' event fires
 */
VideoPlaybackMonitor.prototype.handleCanPlay = function () {
    this.videoDuration = Math.round(this.video.duration * 1000);
};

/**
 * Remove event listeners stored during instantiation
 */
VideoPlaybackMonitor.prototype.removeListeners = function () {
    this.listeners.forEach(function (listener) {
        this.video.removeEventListener(listener.event, listener.handler);
    }, this);
};

/**
 * Log the data for eventual upload to database
 */
VideoPlaybackMonitor.prototype.logData = function () {
    // could have a play event but no time updates
    var avgDiffPerSecond = 0;
    var runningTimeDiffs = [];
    var standardDeviation = 0;
    var timeDiffsPastThreshold = 0;

    if (this.timeUpdates.length > 0) {
        var lastUpdate = this.timeUpdates.slice(-1)[0];
        avgDiffPerSecond = (lastUpdate.absoluteTimeDiff / lastUpdate.timerTime) * 1000;
        this.timeUpdates.forEach(function (update) {
            runningTimeDiffs.push(update.runningTimeDiffPerSecond);
            if (update.runningTimeDiffPerSecond < MILLISECONDS_THRESHOLD) {
                timeDiffsPastThreshold++;
            }
        });

        standardDeviation = Stats.standardDeviation(runningTimeDiffs, avgDiffPerSecond);
    }

    var displayId = Signage.displayId;

    if (displayId === null) {
        if (Signage.displays.length === 1) {
            displayId = Signage.displays[0].id;
        }
    }

    var videoName;

    if (this.data.widgetType === 'announcement') {
        videoName = $(this.video).closest('[id*="announcement"]')[0].dataset.announcementName;
    } else {
        videoName = this.video.dataset.videoName;
    }

    var partitionedTimeUpdates = _.partition(this.timeUpdates, function (timeUpdate) {
        return timeUpdate.runningTimeDiffPerSecond < MILLISECONDS_THRESHOLD;
    });

    MonitorCollection.totalPlays++;

    var data = {
        avgDiffPerSecond: avgDiffPerSecond,
        avgGoodDiffPerSecond: Stats.mean(
            _.pluck(partitionedTimeUpdates[1], 'runningTimeDiffPerSecond')
        ),
        displayId: displayId,
        displayName: displayId === null ? null : Signage.getDisplayById(displayId).name,
        emptiedBeforeEnded: this.emptiedBeforeVideoEnd,
        playbackError: this.playbackError,
        playStart: this.timerStart,
        numberOfPointsPastThreshold: timeDiffsPastThreshold,
        signageUpTime: Signage.GetUptime(),
        standardDeviation: standardDeviation,
        threshold: MILLISECONDS_THRESHOLD,
        timeUpdates: partitionedTimeUpdates[0],
        totalPlaysThisUpTime: MonitorCollection.totalPlays,
        videoDuration: this.videoDuration,
        videoUuid: this.video.dataset.videoUuid,
        videoName: videoName,
        widgetId: parseInt(this.data.widgetId),
        widgetType: this.data.widgetType,
    };

    Log.Notice('video played', 'SIGNAGE_VIDEO_PLAYBACK_EVENT', __fileline, data);

    Log.Notice('Count video playback event', 'SIGNAGE_VIDEO_PLAYBACK_EVENT_COUNTER', __fileline);

    MonitorCollection.logData(data);
};

/**
 *
 * @param {*} video
 * @todo document this
 */
function getWidgetId(video) {
    var idArray = video.id.split('_');
    return idArray[idArray.length - 1];
}

// -------------------------------------------------------------------------- //

/**
 * @class
 * @hideconstructor
 */
var MonitorCollection = {
    monitors: [],
    videoPlaybackData: {},
    observer: null,
    overallHealth: 1, // percentage of videos where lastPlackbackPerformant is true
    length: 0,
    totalPlays: 0,
    /** @type {function} */
    start: undefined,
    /** @type {function} */
    stop: undefined,
    /** @type {function} */
    logData: undefined,
};

/**
 * Start monitoring videos
 */
MonitorCollection.start = function () {
    var videoArray = Array.prototype.slice.call(document.querySelectorAll('video'));
    videoArray
        // .filter(srcIsRelevant)
        .forEach(function (video) {
            MonitorCollection.monitors.push(new VideoPlaybackMonitor(video));
        });

    // target for the mutation observer
    var target = document.querySelector('body');

    // create an observer instance
    this.observer = new MutationObserver(function (mutations) {
        mutations
            .filter(function (mutation) {
                return mutation.addedNodes.length > 0;
            })
            .map(function (mutation) {
                var videos = $(mutation.addedNodes).find('video');
                return Array.prototype.slice.call(videos);
            })
            .reduce(function (acc, cur) {
                return acc.concat(cur);
            }, [])
            .forEach(function (video) {
                MonitorCollection.monitors.push(new VideoPlaybackMonitor(video));
            });
    });

    // configuration of the observer:
    var observerConfig = {
        childList: true,
        attributes: false,
        characterData: false,
        subtree: true,
    };

    // pass in the target node, and the observer options
    this.observer.observe(target, observerConfig);
};

/**
 * Stop monitoring videos
 */
MonitorCollection.stop = function () {
    this.observer.disconnect();
    this.monitors.forEach(function (monitor) {
        monitor.removeListeners();
    });
    this.monitors = [];
};

/**
 *
 * @param {*} data
 * @todo document this
 */
MonitorCollection.logData = function (data) {
    if (typeof this.videoPlaybackData[data.id] === 'undefined') {
        this.videoPlaybackData[data.id] = {
            count: 0,
            diffPerSecond: [],
            avgDiffPerSecond: null,
            deviation: [],
            emptiedCount: 0,
            underPerformingCount: 0,
            src: data.src,
            id: data.id,
            lastPlaybackPerformant: true,
            standardDeviation: [],
        };
        MonitorCollection.length++;
    }

    var playbackData = this.videoPlaybackData[data.id];
    playbackData.count++;
    if (data.emptiedBeforeEnded) {
        playbackData.emptiedCount++;
    }
    playbackData.diffPerSecond.push(data.avgDiffPerSecond);
    playbackData.avgDiffPerSecond = Stats.mean(playbackData.diffPerSecond);

    playbackData.standardDeviation.push(
        Stats.standardDeviation(playbackData.diffPerSecond, playbackData.avgDiffPerSecond)
    );

    playbackData.deviation.push(
        playbackData.diffPerSecond.slice(-1)[0] - playbackData.avgDiffPerSecond
    );

    if (
        data.emptiedBeforeEnded ||
        playbackData.avgDiffPerSecond < -33 ||
        playbackData.deviation < -16
    ) {
        playbackData.underPerformingCount++;
        playbackData.lastPlaybackPerformant = false;
    } else {
        playbackData.lastPlaybackPerformant = true;
    }

    playbackData.health =
        (playbackData.count - playbackData.underPerformingCount) / playbackData.count;

    // make sure all videos have played before checking overall health
    if (document.querySelectorAll('video').length === MonitorCollection.length) {
        var numberOfPerformantVideos = 0;
        for (let video in this.videoPlaybackData) {
            if (this.videoPlaybackData[video].lastPlaybackPerformant) {
                numberOfPerformantVideos++;
            }
        }
        MonitorCollection.overallHealth = numberOfPerformantVideos / MonitorCollection.length;
    }
};

export { VideoPlaybackMonitor, MonitorCollection };
